// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18m91wug{overflow-y:auto}\n._1e0c1txw{display:flex}\n._1fjgurpi{scrollbar-width:thin}\n._2lx21bp4{flex-direction:column}\n._a5o91eti{scrollbar-color:var(--ds-border,#091e4224) transparent}\n._ln191tx6{scrollbar-gutter:stable both-edges}", ""]);
// Exports
module.exports = exports;
